import { createContext } from 'react'

import type { Gif } from '../types'
import type { ExplicitRating } from '../../../../functions/src/shared/types/gif'

interface SearchState {
  results: Gif[]
  loading: boolean
  error: string | null
  query: string
  hasSearched: boolean
  totalHits: number
  suggestions: string[]
  loadingSuggestions: boolean
}

interface SearchActions {
  search: (query: string, ratingFilter: ExplicitRating) => Promise<void>
  clearSearch: () => void
  getSuggestions: (query: string) => Promise<void>
  clearSuggestions: () => void
}

export type SearchContextType = SearchState & SearchActions

export const SearchContext = createContext<SearchContextType | undefined>(
  undefined
)
